import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { listingTypes } from 'entoro-shared';
import { FormControl, Select, MenuItem } from 'material-ui';

const tabIsActive = (match, location, type) => {
  const params = new URLSearchParams(location.search);
  const listingType = params.get('listingType');

  if (match && !listingType) {
    return true;
  } else if (listingType === type) {
    return true;
  }
  return false;
};

const getFilterValue = (location) => {
  const params = new URLSearchParams(location.search);
  let listingType = params.get('listingType');
  if (!listingType) {
    listingType = location.pathname
      .replace('/dashboard/', '')
      .replace('-', '_')
      .toUpperCase();
  }
  return listingType;
};

const createFilterOptions = (tenant, isAuthenticated) => {
  const availableListingTypes = get(tenant, 'availableListingTypes', []);
  const baseUrl = !isAuthenticated ? '/' : '/dashboard/all-offers';
  const newFilterOptions = {};

  if (availableListingTypes.length > 1) {
    newFilterOptions.ALL_OFFERS = {
      to: baseUrl,
      title: 'All Listing Types',
    };
  }

  const filteredListingTypeOptions = availableListingTypes.map(
    (availableListingType) =>
      listingTypes.options.find(({ value }) => value === availableListingType)
  );

  filteredListingTypeOptions.forEach(({ value, label }) => {
    newFilterOptions[value] = {
      to: `${baseUrl}?listingType=${value}`,
      title: label,
    };
  });

  return newFilterOptions;
};

const FilterOption = ({ filterOptions, option }) => (
  <NavLink
    key={option}
    className='_2nd-nav-link w-nav-link'
    activeClassName='active-link'
    to={filterOptions[option].to}
    isActive={(match, location) => tabIsActive(match, location, option)}
  >
    {filterOptions[option].title}
  </NavLink>
);

FilterOption.propTypes = {
  filterOptions: PropTypes.object.isRequired,
  option: PropTypes.string.isRequired,
};

class OfferNavListingType extends React.Component {
  constructor(props) {
    super(props);
    const listingType = getFilterValue(props.location);

    this.state = {
      listingType: listingType || 'ALL_OFFERS',
    };
  }

  onChange = (e) => {
    const listingType = e.target.value;
    const baseUrl = !this.props.isAuthenticated ? '/' : '/dashboard/all-offers';
    let newUrl = `${baseUrl}?listingType=${listingType}`;

    this.setState({ listingType });
    window.location.href = newUrl;
  };

  render() {
    const { tenant } = this.context;
    const { listingType } = this.state;
    const { isAuthenticated } = this.props;
    const filterOptions = createFilterOptions(tenant, isAuthenticated);

    return (
      <div className='nav-menu-4 w-nav-menu' style={{ flexWrap: 'wrap' }}>
        {Object.keys(filterOptions).map((option) => (
          <FilterOption
            key={option}
            filterOptions={filterOptions}
            option={option}
          />
        ))}
        <FormControl>
          <Select
            value={listingType}
            name='filters'
            onChange={this.onChange}
            className='filters-small-screen'
          >
            {Object.keys(filterOptions).map((option) => (
              <MenuItem key={option} value={option}>
                {filterOptions[option].title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

OfferNavListingType.contextTypes = {
  tenant: PropTypes.object,
};

OfferNavListingType.propTypes = {
  location: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ session }) => ({
  isAuthenticated: session.isAuthenticated,
});

const OfferNavConnected = connect(mapStateToProps)(
  withRouter(OfferNavListingType)
);

export {
  OfferNavConnected as OfferNavListingType,
  createFilterOptions,
  tabIsActive,
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/OfferNavListingType.js